import { useRoute } from "#vue-router";
export const getPathStatus = (path) => {
  const route = useRoute();
  const currentPath = route.path;
  const currentPathWithoutTrailingSlash = currentPath.replace(/\/+$/, "");
  const trimmedPath = path.replace(/\/+$/, "").split("?")[0];
  const currentSlugs = currentPathWithoutTrailingSlash.split("/").filter(Boolean);
  const targetSlugs = trimmedPath.split("/").filter(Boolean);
  const isActive = targetSlugs.every(
    (slug, index) => slug === currentSlugs[index]
  );
  const isActiveExact = isActive && currentPathWithoutTrailingSlash === trimmedPath;
  return { isActive, isActiveExact };
};
export const getPathStatusClasses = (path) => {
  const { isActive, isActiveExact } = getPathStatus(path);
  return {
    "router-link-active": isActive,
    "router-link-exact-active": isActiveExact
  };
};
export const replaceText = (text, pattern, replacement) => {
  if (!replacement || !pattern) {
    return text;
  }
  return text.replace(pattern, replacement);
};
